




































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { getSubgroups } from '@/services/groups';
import * as service from '@/services/products';
import IProduct from '@/interfaces/product';
import ProductModel from '@/models/product-model';
import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiToggleStatus from '@/components/UI/toggle-status.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import ProductForm from '@/components/products/product-form.vue';
import { sortKey } from '@/helpers/sort';
import { convertCharacters } from '@/helpers/convertCharacters';
import { errorHandling } from '@/helpers/errorHandling';
import { ERROR_CODE_PRODUCTS_CONFLICT } from '@/settings/consts/api-error';
import { MESSAGE_PRODUCT_DELETE_ERROR } from '@/settings/consts/messages';
import { resetModalScroll } from '@/helpers/resetModalScroll';

@Component({
  components: { PermissionAuth, ListMessages, UiToggleStatus, ProductForm },
})
export default class Products extends BaseComponent {
  public formOpen: boolean = false;
  public error: boolean = false;
  public loading: boolean = false;

  public filter: any = {
    term: null,
    status: null,
    subgroup: null,
  };

  public statusList: any[] = [
    {
      value: null,
      label: 'Todos',
    },
    {
      value: true,
      label: 'Ativo',
    },
    {
      value: false,
      label: 'Inativo',
    },
  ];

  public headers: any[] = [
    { text: 'Código', value: 'codigo' },
    { text: 'Nome', value: 'descricao' },
    { text: 'Grupo/Subgrupo', value: 'subgrupo', sortable: false },
    {
      text: 'Unidades de medida',
      align: 'center',
      value: 'unidades',
      sortable: false,
    },
    { text: 'Ações', value: 'actions', align: 'right', sortable: false },
  ];
  public data: IProduct[] = [];
  public item: ProductModel = new ProductModel();
  public subgroups: any[] = [];

  public onFilter(): void {
    this.load();
  }

  public beforeMount(): void {
    this.load();
    this.getSubgroups();
  }

  public onEditItem(item: IProduct): void {
    this.loader.start('Carregando item...');
    service.getProduct(item.id).subscribe(
      (data) => {
        this.item = new ProductModel(data);
        this.loader.stop();
        this.formOpen = true;
      },
      () => {
        this.loader.stop();
        this.toast.show('Ocorreu um erro ao carregar o item', 'error');
      },
    );
  }

  public customFilter(items, search, filter): any[] {
    const searchLower = !!this.filter.term
      ? convertCharacters(this.filter.term.toString().toLowerCase())
      : null;
    return items.filter((row) => {
      return (
        (!searchLower ||
          filter(convertCharacters(row.descricao), searchLower) ||
          filter(convertCharacters(row.codigo), searchLower)) &&
        (!this.filter.subgroup || row.subgrupo.id === this.filter.subgroup)
      );
    });
  }

  public onDeleteItem(item: IProduct): void {
    const deleteItem = () => {
      const onError = (error) => {
        this.loader.stop();

        const responseMessage = !!error.data
          ? error.data.message
          : MESSAGE_PRODUCT_DELETE_ERROR;
        const errorMessages = {
          default: MESSAGE_PRODUCT_DELETE_ERROR,
          [ERROR_CODE_PRODUCTS_CONFLICT]: responseMessage,
        };

        const message = errorHandling(error, errorMessages);

        this.toast.show(message, 'error');
      };

      this.loader.start('Deletando registro...');
      service.deleteProduct(item.id).subscribe((data) => {
        this.loader.stop();
        this.load();
      }, onError);
    };

    this.dialog.show(
      'error',
      'Excluir Produto',
      'Tem certeza que deseja excluir este produto?',
      'Cancelar',
      '',
      'Excluir',
      deleteItem,
    );
  }

  public toggleItemStatus(item: ProductModel, status: boolean): void {
    this.loader.start('Atualizando registro...');
    const payload = item.toJson();
    payload.ativo = status;
    service.updateProduct(payload).subscribe(
      (data) => {
        item.ativo = status;
        this.loader.stop();
      },
      () => {
        this.loader.stop();
        this.toast.show('Ocorreu um erro ao atualizar o produto', 'error');
      },
    );
  }

  public onSave(): void {
    this.closeForm();
    this.load();
  }

  public newItem(item): void {
    this.item = new ProductModel();
    this.formOpen = true;
  }

  public closeForm(): void {
    this.item = null;
    this.formOpen = false;
    resetModalScroll();
  }

  private load(): void {
    this.data = [];
    this.loading = true;
    service.getProducts(this.filter).subscribe(
      (data) => {
        this.data = data.map((item) => new ProductModel(item));
        this.loading = false;
      },
      () => {
        this.loading = false;
        this.error = true;
      },
    );
  }

  private getSubgroups(): void {
    getSubgroups().subscribe(
      (data) => {
        const subgroups = [];

        data.reduce((items, item) => {
          items.push({
            ...item,
            nome: `${item.grupo.nome} / ${item.nome}`,
          });
          return items;
        }, subgroups);

        this.subgroups = subgroups.sort(sortKey('nome'));
      },
      () => {
        this.toast.show('Ocorreu um erro ao carregar os subgrupos.', 'error');
      },
    );
  }
}
